import { FC, SVGProps } from 'react';

export const AccountMenuIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
		<g clipPath="url(#clip0_1518_82)">
			<path
				d="M5.23593 5.04166L7.66649 2.6111L10.097 5.04166"
				stroke="currentColor"
				strokeWidth="1.19048"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.23593 10.9583L7.66649 13.3889L10.097 10.9583"
				stroke="currentColor"
				strokeWidth="1.19048"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1518_82">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
